import { PaletteColorOptions, TypeBackground } from "@mui/material";
import { IContext } from "./types";

export const primary: PaletteColorOptions = {
  main: "#1fc2ac",
  dark: "#137d6f",
  light: "#57C5B6",
  shade: "#d7faf6",
  contrastText: "#f2fcfc",
};

export const secondary: PaletteColorOptions = {
  main: "#3972bd",
  dark: "#153D76",
  light: "#5989c9",
  shade: "#E2EEFF",
  contrastText: "#F6F6FF",
};

export const tertiary: PaletteColorOptions = {
  main: "#FE7D07",
  dark: "#FEA14A",
  light: "#FDB16A",
  shade: "#FFEAD7",
  contrastText: "#fcf6f0",
};

export const error: PaletteColorOptions = {
  main: "#DC3545",
  light: "#FFEDEF",
};

export const info: PaletteColorOptions = {
  main: "#0DA7A7",
  light: "#EDFFFF",
};

export const success: PaletteColorOptions = {
  main: "#20BC7A",
  light: "#E9FFF6",
};

export const warning: PaletteColorOptions = {
  main: "#FAC641",
  light: "#FFF9EA",
};

export const context: IContext = {
  primary: "#13305D",
  secondary: "#560322",
  tertiary: "#99510D",
  veryLight: "#D1D3DA",
  light: "#979BA5",
  dark: "#595D6B",
  black: "#111629",
  white: "#F6F6FF",
  green: "#1fc2ac",
};

export const background: TypeBackground = {
  default: "#EEEEEF",
  paper: "#FEFEFF",
};

export { grey, blue } from "@mui/material/colors";
